package model.impl

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import model.NavigationRepository
import model.NavigationRepository.DialogState
import navigation.Navigation
import navigation.NavigationState
import org.koin.core.component.KoinComponent
import ui.snackbars.SnackBarState

class DefaultNavigationRepository(
    override val navigation: Navigation,
) : NavigationRepository, KoinComponent {

    override val dialogStateMutableStateFlow: MutableStateFlow<DialogState> = MutableStateFlow(DialogState.Nothing())
    override val navigationStateFlow = navigation.navigationStateFlow
    override val backStackStateFlow = navigation.backStackStateFlow

    override val snackbarStateMutableStateFlow: MutableStateFlow<SnackBarState> = MutableStateFlow(SnackBarState.Nothing())
    override val snackbarStateStateFlow = snackbarStateMutableStateFlow.asStateFlow()

    override fun setSnackbarState(state: SnackBarState) {
        snackbarStateMutableStateFlow.value = state
    }

    override fun navigate(navigationState: NavigationState) = navigation.navigate(navigationState)
    override fun popBackStack() = navigation.popBackStack()
    override fun hashStateChangeEvent(newHash: String, locationListener: (String) -> Unit) =
        navigation.hashStateChangeEvent(newHash, locationListener)
}